export const Ok = 0;
export const InvalidOldPIN = 1;
export const PINLong = 2;